import React from 'react';
import PropTypes from 'prop-types';

import { useResponsiveBreakpoints } from '../hooks/useResponsiveBreakpoints';

import SortControls from './SortControls/SortControls';
import ClientSideFilteredSearchBar from './ClientSideFilteredSearchBar/ClientSideFilteredSearchBar';
import SearchBarWithUrlParamsHandling from './SearchBarWithUrlParamsHandling/SearchBarWithUrlParamsHandling';

const PageHeader = ({
    title,
    description,
    sortOptions,
    backgroundColor = 'white',
    isClientSideFiltering = false,
    list = [], // used when Client Side Filtering
    setFilteredList = () => {}, // used when Client Side Filtering
    useExternalQuery = false, // used when Client Side Filtering
    query, // used when Client Side Filtering
    setQuery = () => {}, // used when Client Side Filtering
    usePagination = true,
    usePageState = false,
    resetPageState = () => {},
}) => {
    const { isMobile } = useResponsiveBreakpoints();

    return (
        <div
            className="w-full p-5 md:p-6 lg:p-8 flex flex-col gap-5 md:gap-6 lg:gap-10"
            style={{ backgroundColor }}
        >
            <div className="max-w-[650px] flex flex-col gap-1 md:gap-0 items-center mx-auto">
                <h1 className="font-heading-bold text-heading-bold-l md:text-heading-bold-xl text-black text-center">
                    {title}
                </h1>
                <p className="font-body text-body-regular-m md:text-body-regular-l text-neutral-300 text-center max-w-[360px] sm:max-w-full">
                    {description}
                </p>
            </div>

            <div className="w-full flex flex-col gap-2.5 items-center">
                <div className="w-full max-w-[400px] md:max-w-[600px]">
                    {isClientSideFiltering && (
                        <ClientSideFilteredSearchBar
                            size={isMobile ? 'sm' : 'md'}
                            list={list}
                            setFilteredList={setFilteredList}
                            keyToFilter={['name']}
                            useExternalQuery={useExternalQuery}
                            query={query}
                            setQuery={setQuery}
                        />
                    )}

                    {!isClientSideFiltering && (
                        <SearchBarWithUrlParamsHandling
                            size={isMobile ? 'sm' : 'md'}
                            placeholder="Search by keyword"
                        />
                    )}
                </div>
                <SortControls
                    sortOptions={sortOptions}
                    variant="inline"
                    usePagination={usePagination}
                    usePageState={usePageState}
                    resetPageState={resetPageState}
                />
            </div>
        </div>
    );
};

PageHeader.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.string.isRequired,
    sortOptions: PropTypes.array,
    backgroundColor: PropTypes.string,
    isClientSideFiltering: PropTypes.bool,
    list: PropTypes.array,
    setFilteredList: PropTypes.func,
    useExternalQuery: PropTypes.bool,
    query: PropTypes.string,
    setQuery: PropTypes.func,
    usePagination: PropTypes.bool,
    usePageState: PropTypes.bool,
    resetPageState: PropTypes.func,
};

export default PageHeader;
